module.exports = __webpack_public_path__ + "img/marie-rousseau.8ab4c541.jpg";